var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import { Box } from "../box";
import { makeStyles } from "../styles";
import { TitleBlock } from "../title-block";
import clsx from "../utils/clsx";
import { getCosmosDataProps } from "../utils/comsosCompat";
var AvatarBlockComponentName = "CosmosAvatarBlock";
var useAvatarBlockStyles = makeStyles(function (theme) { return ({
    root: {},
    avatar: {
        marginRight: theme.spacing(2),
    },
    titleBlock: {},
}); }, { name: AvatarBlockComponentName });
export var AvatarBlock = React.forwardRef(function (props, ref) {
    var classes = useAvatarBlockStyles(props);
    var avatar = props.avatar, title = props.title, description = props.description, className = props.className, titleTypographyProps = props.titleTypographyProps, descriptionTypographyProps = props.descriptionTypographyProps, _a = props.TitleBlockProps, TitleBlockProps = _a === void 0 ? {} : _a, 
    // don't forward on to the root
    propClasses = props.classes, rootProps = __rest(props, ["avatar", "title", "description", "className", "titleTypographyProps", "descriptionTypographyProps", "TitleBlockProps", "classes"]);
    return (React.createElement(Box, __assign({ className: clsx(classes.root, className) }, { ref: ref }, { display: "flex", alignItems: !!description ? "flex-start" : "center" }, getCosmosDataProps("avatar-block"), rootProps),
        avatar && React.createElement(Box, { className: classes.avatar }, avatar),
        React.createElement(TitleBlock, __assign({ className: classes.titleBlock, title: title, description: description, titleTypographyProps: __assign({ noWrap: true, component: "p" }, titleTypographyProps), descriptionTypographyProps: descriptionTypographyProps }, TitleBlockProps))));
});
